import type SubjectAddress from '@Domain/Subjects/SubjectAddress';
import SpeakerAssignmentChoiceButton from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/SpeakerAssignmentSidebar/SpeakerAssignmentChoices/SpeakerAssignmentChoiceButton';
import useAssignTranscriptSpeaker from '@UI/Pages/Beneficiaries/BeneficiaryDetails/Pages/Interviews/InterviewDetails/SpeakerAssignmentSidebar/Hooks/useAssignTranscriptSpeaker';
import * as React from 'react';

type Props = {
	readonly facilityId: number;
	readonly subject: SubjectAddress;
	readonly interviewId: number;
	readonly speakerId: number;
	readonly contactId: number;
	readonly label: string;
	readonly selected: boolean;
};

/** One dossier contact, offered as a `kind = contact` choice — a participant of the interview first. */
const SpeakerAssignmentContactChoice: React.FC<Props> = ({
	facilityId,
	subject,
	interviewId,
	speakerId,
	contactId,
	label,
	selected,
}) => {
	const assign = useAssignTranscriptSpeaker(facilityId, subject, interviewId, speakerId);

	const handleClick = React.useCallback(() => {
		assign('contact', contactId, null, null);
	}, [assign, contactId]);

	return <SpeakerAssignmentChoiceButton label={label} selected={selected} onClick={handleClick} />;
};

export default SpeakerAssignmentContactChoice;
